import React, { useState, useEffect } from "react";
import { Modal, Text, Button, Textarea, Loading, Divider } from "@nextui-org/react";

const AltEntriesClearModal = ({
  visible,
  kpiStats = {},
  clearableCount = 0,
  clearing,
  onClose,
  onConfirm,
}) => {
  const [clearNote, setClearNote] = useState("");

  const {
    shopTotal = 0,
    sunilC = 0,
    customerTotal = 0,
    profit = 0,
  } = kpiStats;

  useEffect(() => {
    if (visible) {
      setClearNote("");
    }
  }, [visible]);

  const handleConfirm = () => {
    onConfirm({ note: clearNote.trim() });
  };

  return (
    <Modal
      closeButton
      aria-labelledby="clear-modal-title"
      open={visible}
      onClose={onClose}
    >
      <Modal.Header>
        <Text id="clear-modal-title" b size={18}>
          Clear Selected Entries
        </Text>
      </Modal.Header>
      <Modal.Body css={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <Text size="14px" color="error">
          Warning: This will permanently mark {clearableCount} entr{clearableCount === 1 ? "y" : "ies"} as cleared. Cleared entries cannot be cleared again.
        </Text>

        <Divider />
        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
          <div className="groupCardFlex">
            <Text size="13px" b>Shop Total:</Text>
            <Text size="13px" b color="warning">₹ {Math.ceil(shopTotal).toLocaleString("en-IN")}</Text>
          </div>
          <div className="groupCardFlex">
            <Text size="13px" b>Sunil C:</Text>
            <Text size="13px" b color="error">₹ {Math.ceil(sunilC).toLocaleString("en-IN")}</Text>
          </div>
          <div className="groupCardFlex">
            <Text size="13px" b>Customer:</Text>
            <Text size="13px" b color="default">₹ {Math.ceil(customerTotal).toLocaleString("en-IN")}</Text>
          </div>
          <div className="groupCardFlex">
            <Text size="13px" b>Profit:</Text>
            <Text size="13px" b color={profit >= 0 ? "secondary" : "error"}>
              ₹ {Math.ceil(profit).toLocaleString("en-IN")}
            </Text>
          </div>
        </div>
        <Divider />

        <Textarea
          fullWidth
          bordered
          label="Note (Optional)"
          placeholder="Add a note or reason for clearing entries..."
          value={clearNote}
          onChange={(e) => setClearNote(e.currentTarget.value)}
          rows={2}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button auto flat color="default" onClick={onClose}>
          Cancel
        </Button>
        <Button
          auto
          color="error"
          disabled={clearing || clearableCount === 0}
          onClick={handleConfirm}
        >
          {clearing ? (
            <Loading type="spinner" color="white" size="sm" />
          ) : (
            `Confirm Clear (${clearableCount})`
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AltEntriesClearModal;
